module.exports = __webpack_public_path__ + "static/img/banner_sdk.3c8ebfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/banner/banner_sdk.jpg
// module id = pkHJ
// module chunks = 0